import { Badge } from "../ui/badge";

export const ROLE_LABEL = { customer: "Customer", partner: "Partner", admin: "VECTRON Admin" };
export const STATUS_LABEL = { active: "Active", pending: "Pending", suspended: "Suspended", disabled: "Disabled", archived: "Archived" };
export const LOGIN_LABEL = { never: "Never logged in", active_24h: "Logged in <24h", recent_30d: "Logged in <30d", inactive: "Inactive >30d", locked: "Locked" };

const STATUS_CLS = {
  active: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30",
  pending: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30",
  suspended: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/30",
  disabled: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30",
  archived: "bg-muted text-muted-foreground border-border",
};
const LOGIN_CLS = { locked: "text-red-600 dark:text-red-400 border-red-500/30", active_24h: "text-emerald-700 dark:text-emerald-400 border-emerald-500/30", never: "text-muted-foreground" };

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const StatusBadge = ({ status, testId }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold uppercase tracking-wide ${STATUS_CLS[status] || STATUS_CLS.archived}`} data-testid={testId}>{STATUS_LABEL[status] || status}</span>
);

export const RoleBadge = ({ role, testId }) => <Badge variant="outline" className="text-xs font-medium" data-testid={testId}>{ROLE_LABEL[role] || role}</Badge>;

export const LoginBadge = ({ status, testId }) => (
  <Badge variant="outline" className={`text-xs ${LOGIN_CLS[status] || ""}`} data-testid={testId}>{LOGIN_LABEL[status] || status}</Badge>
);

export const Field = ({ label, children, testId }) => (
  <div className="space-y-0.5" data-testid={testId}>
    <p className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
    <div className="text-sm break-words">{children ?? "—"}</div>
  </div>
);
